import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6.664c.552 0 1-.458 1-1.023 0-1.257.783-1.832 2.698-2.03.424-.044.858-.066 1.302-.066.444 0 .878.022 1.302.066C27.216 3.81 28 4.384 28 5.641c0 .565.448 1.023 1 1.023s1-.458 1-1.023c0-2.538-1.684-3.774-4.497-4.065a14.827 14.827 0 0 0-3.006 0C19.684 1.866 18 3.104 18 5.641c0 .565.448 1.023 1 1.023Zm21 17.303V15.81c.397-.02.673-.094.96-.25a1.93 1.93 0 0 0 .788-.806c.187-.358.252-.7.252-1.27V11.72c-.005-2.257-1.797-4.082-4.002-4.077l-13.76.03h-.116l-14.127-.03C7.788 7.643 6 9.47 6 11.727v1.757c0 .57.065.913.252 1.27.18.346.45.622.788.807.287.156.563.23.96.25v8.255c0 5.517.18 10.66.54 15.427.262 3.479 2.939 6.258 6.336 6.578a96.766 96.766 0 0 0 18.247-.003c3.398-.32 6.076-3.1 6.338-6.58.36-4.776.539-9.95.539-15.521ZM20 37.175c0 .565-.448 1.023-1 1.023s-1-.458-1-1.023V18.886c0-.564.448-1.022 1-1.022s1 .457 1 1.022v18.29Zm10 0c0 .565-.448 1.023-1 1.023s-1-.458-1-1.023V18.886c0-.564.448-1.022 1-1.022s1 .457 1 1.022v18.29Z",
    fill: "currentColor"
  }));
};

var SvgTrash = styled(SvgComponent).withConfig({
  displayName: "Trash__SvgTrash",
  componentId: "sc-vktlro-0"
})(["", " ", ""], size, color);
export default SvgTrash;